export default "__VITE_ASSET__979d7db4__"